module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_pp3_5010.62b6f38a.png";